/**
 * Configuração centralizada do Auth Portal.
 * Todas as variáveis de ambiente consumidas no bundle estático são lidas aqui.
 */

function sanitizeBaseUrl(url?: string): string {
  if (!url || url.trim() === "") {
    return "http://localhost:3001";
  }
  return url.trim().replace(/\/+$/, "");
}

export const Config = {
  /**
   * URL base da Auth API
   */
  authApiUrl: sanitizeBaseUrl(import.meta.env.VITE_AUTH_API_URL),

  /**
   * Client ID padrão da aplicação mestre de administração
   */
  defaultClientId: import.meta.env.VITE_DEFAULT_CLIENT_ID || "auth-admin",

  /**
   * Título da aplicação
   */
  appTitle: import.meta.env.VITE_APP_TITLE || "Auth Portal Admin",

  /**
   * Política de armazenamento de token (estritamente 'memory')
   */
  tokenStorage: "memory" as const,

  /**
   * Limites de paginação
   */
  pagination: {
    defaultLimit: 10,
    maxLimit: 100,
  },
} as const;

export type AppConfig = typeof Config;
